import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EMAIL_VALIDATION_PATTERN, NAME_VALIDATION_PATTERN } from '@shared/constant/shared.constant';
import { EnquiryRequest } from '@core/models/enquiry.model';
import { CustomValidator } from '@shared/services/custom-validatior.abstract';
import { LandingService } from '@core/services/landing.service';
import { ToastService } from '@shared/services/toast.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-footer-form',
  templateUrl: './footer-form.component.html',
  styleUrls: ['./footer-form.component.scss']
})
export class FooterFormComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  landingForm: FormGroup;
  NAME_MAX_LENGTH: number = 50;

  constructor(
    private readonly formbuilder: FormBuilder,
    private readonly landingService: LandingService,
    private readonly toastService: ToastService) {

  }
  ngOnInit(): void {
    this.landingForm = this.formbuilder.group({
      name: ['', [Validators.required, Validators.pattern(NAME_VALIDATION_PATTERN),Validators.minLength(3)]],
      businessName: [''],
      email: ['', [Validators.required, Validators.pattern(EMAIL_VALIDATION_PATTERN)]],
      phoneNumber: ['', [Validators.required, Validators.pattern('[0-9]*'), Validators.minLength(9), Validators.maxLength(15)]],
      message: ['', [Validators.required,Validators.minLength(3)]]
    });
  }

  createEnquiry(): void {
    if (this.landingForm.valid) {
      
      const enquiryRequest: EnquiryRequest = Object.assign({}, this.landingForm.value);
      this.landingService.createEnquiry(enquiryRequest)
      .pipe(autoUnsubWith(this.destroyRef))
        .subscribe({
          next: () => {
            this.toastService.showToastMessage('success', 'Success', 'Enquiry sent successfully!');
            this.landingForm.reset();
          },
          error: (err) => {
            this.toastService.showToastMessage('error', 'Error', err.error.message);
            
          }
        });
    } else {
      CustomValidator.markFormGroupTouched(this.landingForm);
    }
  }

  onKeyPress(event: KeyboardEvent): void {
    const allowedChars = /[0-9]/;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }}
}
